import React from 'react';
import './StatsOverview.css';
import ProgressBar from './ProgressBar';

function StatsOverview({ stats }) {
  return (
    <div className="stats-overview">
      <div className="stats-overview-header">
        <h2>📊 Platform Statistics</h2>
      </div>
      <div className="stats-overview-grid">
        <div className="stat-card-enhanced">
          <div className="stat-icon-wrapper">
            <div className="stat-icon-bg" style={{ background: 'linear-gradient(135deg, #6361e7, #7c5cf5)' }}>
              <span className="stat-icon">👥</span>
            </div>
          </div>
          <div className="stat-content-enhanced">
            <h3>{stats?.totalUsers || 0}</h3>
            <p>Total Users</p>
            <div className="stat-trend">
              <span className="trend-up">↑ 12%</span>
              <span className="trend-label">vs last month</span>
            </div>
          </div>
        </div>

        <div className="stat-card-enhanced">
          <div className="stat-icon-wrapper">
            <div className="stat-icon-bg" style={{ background: 'linear-gradient(135deg, #10de82, #34d399)' }}>
              <span className="stat-icon">🎁</span>
            </div>
          </div>
          <div className="stat-content-enhanced">
            <h3>{stats?.totalGiveaways || 0}</h3>
            <p>Active Giveaways</p>
            <div className="stat-trend">
              <span className="trend-up">↑ 8%</span>
              <span className="trend-label">vs last month</span>
            </div>
          </div>
        </div>

        <div className="stat-card-enhanced">
          <div className="stat-icon-wrapper">
            <div className="stat-icon-bg" style={{ background: 'linear-gradient(135deg, #f59e0b, #fbbf24)' }}>
              <span className="stat-icon">🎯</span>
            </div>
          </div>
          <div className="stat-content-enhanced">
            <h3>{stats?.totalEntries || 0}</h3>
            <p>Total Entries</p>
            <div className="stat-trend">
              <span className="trend-up">↑ 25%</span>
              <span className="trend-label">vs last month</span>
            </div>
          </div>
        </div>

        <div className="stat-card-enhanced">
          <div className="stat-icon-wrapper">
            <div className="stat-icon-bg" style={{ background: 'linear-gradient(135deg, #ef4444, #f87171)' }}>
              <span className="stat-icon">🏆</span>
            </div>
          </div>
          <div className="stat-content-enhanced">
            <h3>{stats?.totalWins || 0}</h3>
            <p>Total Wins</p>
            <div className="stat-trend">
              <span className="trend-up">↑ 5%</span>
              <span className="trend-label">vs last month</span>
            </div>
          </div>
        </div>
      </div>

      <div className="stats-progress-section">
        <h3>Platform Growth</h3>
        <div className="progress-items">
          <div className="progress-item">
            <div className="progress-header">
              <span>User Engagement</span>
              <span>85%</span>
            </div>
            <ProgressBar value={85} max={100} color="primary" />
          </div>
          <div className="progress-item">
            <div className="progress-header">
              <span>Giveaway Completion</span>
              <span>72%</span>
            </div>
            <ProgressBar value={72} max={100} color="success" />
          </div>
          <div className="progress-item">
            <div className="progress-header">
              <span>User Retention</span>
              <span>68%</span>
            </div>
            <ProgressBar value={68} max={100} color="warning" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsOverview;

